import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
export const UsersModal = observer(_ref => {
  let _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    id = _ref.id;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    data = _useState4[0],
    setData = _useState4[1];
  const handleOpenModal = () => setModalIsOpen(true);
  const fetchAppfolioDate = async () => {
    const resp = await store.credentials.getCredentialsUsersAsync.run({
      credentialsId: id
    });
    if (resp && resp.response && resp.response.length) {
      setData(resp.response);
    }
  };
  useEffect(() => {
    if (modalIsOpen) fetchAppfolioDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalIsOpen]);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: () => setModalIsOpen(false),
    handleOpen: handleOpenModal,
    isOpen: modalIsOpen,
    title: t('Users list'),
    variant: "large",
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "priority",
      onClick: () => setModalIsOpen(true),
      size: "small",
      'custom-attribute': '522-appfolio-page'
    }, t('Show users'))
  }, /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, "External Id"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Email"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "First Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Last Name"), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, "Last Updated At"))), /*#__PURE__*/React.createElement(TableBody, null, data.map(row => /*#__PURE__*/React.createElement(TableRow, {
    key: row.externalId
  }, /*#__PURE__*/React.createElement(TableCell, null, row.externalId), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, row.email), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, row.firstName), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, row.lastName), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, row.lastUpdatedAt)))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.credentials.getGlAccountsAsync.inProgress || store.credentials.getCredentialsAsync.inProgress || store.credentials.postCredentialsAsync.inProgress || store.credentials.patchCredentialsAsync.inProgress || store.credentials.deleteCredentialAsync.inProgress || store.credentials.getCredentialsUsersAsync.inProgress || store.credentials.getCredentialsPropertiesAsync.inProgress || store.credentials.patchCredentialsPropertiesAsync.inProgress
  }));
});